import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AlertNotificationService } from '../../../services/alert-notification.service';

export interface AlertNotification {
  type: 'success' | 'error' | 'warning';
  message: string;
  fadeOut?: boolean; 
  show?: boolean;
}
@Component({
  selector: 'alert-notification',
  imports: [CommonModule],
  templateUrl: './alert-notification.component.html',
  styleUrl: './alert-notification.component.scss'
})
export class AlertNotificationComponent {
  notifications: AlertNotification[] = [];

  constructor(private alertNotificationService: AlertNotificationService) {}

  ngOnInit(): void {
    this.alertNotificationService.notifications$.subscribe(notification => {
     
      this.notifications.push(notification);
      setTimeout(() => {
        notification.show = true; 
      }, 10);

      setTimeout(() => {
        const index = this.notifications.indexOf(notification);
        if (index > -1) {
          this.notifications[index].fadeOut = true;
          setTimeout(() => {
            this.notifications.splice(index, 1);
          }, 500); 
        }
      }, 3000); 
    });
  }
}
